import React from 'react';
import { X } from 'lucide-react';

export default function ConfirmLogoutModal({ trigger, onConfirm }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleConfirm = () => {
    setIsOpen(false);
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const triggerElement = React.cloneElement(trigger, {
    onClick: (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(true);
    }
  });

  return (
    <>
      {triggerElement}

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div 
            className="fixed inset-0 bg-black/40"
            onClick={handleCancel}
          />

          <div className="relative bg-white rounded-lg shadow-xl p-6 w-[90%] max-w-md z-10">
            <button
              onClick={handleCancel}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <X size={20} />
            </button>

            <h2 className="text-lg font-bold text-gray-900 mb-2">
              Confirm Logout
            </h2>
            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to logout? You will need to login again to access your account.
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={handleCancel}
                className="px-4 py-2 rounded bg-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-300 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className="px-4 py-2 rounded bg-red-500 text-white text-sm font-medium hover:bg-red-600 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}